import { render, staticRenderFns } from "./V2Sidebar.vue?vue&type=template&id=ba0e8448&scoped=true"
import script from "./V2Sidebar.vue?vue&type=script&lang=js"
export * from "./V2Sidebar.vue?vue&type=script&lang=js"
import style0 from "./V2Sidebar.vue?vue&type=style&index=0&id=ba0e8448&prod&lang=sass&scoped=true"
import style1 from "./V2Sidebar.vue?vue&type=style&index=1&id=ba0e8448&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0e8448",
  null
  
)

export default component.exports